"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTranslations = void 0;
const defaultTranslations = exports.defaultTranslations = {
  notifications: 'Notifications',
  noNotifications: 'Nothing new. We will notify you as soon as there are news',
  notificationAlreadyRead: 'The notification has already been read',
  notificationRead: 'Mark as Read',
  notificationDismiss: 'Dismiss',
  seeAll: 'See All Notifications',
  myProfile: 'My Profile',
  logout: 'Logout',
  feedback: 'Feedback',
  switchLabel: 'Switch Solutions',
  dateFormat: 'MMM dd, yyyy hh:mm:ss a',
  searchPlaceholder: 'Search',
  noSearchResult: 'Nothing to show',
  appconfigAPIError: 'Cannot load application configuration',
  sitemapAPIError: 'Cannot load sitemap data',
  notificationsAPIError: 'Cannot load notifications',
  wsConnectionError: 'Cannot establish WebSocket connection',
  modalMinutes: 'minute(s)',
  modalSeconds: 'second(s)',
  idleTitle: 'Session timeout',
  idleText: "You've been inactive for a while. For you security, we will automatically log you off in approximately 3 minutes. Do you wish to continue your session?",
  idleConfirm: 'Yes, Continue Session',
  idleCancel: 'No, Log Off',
  lifetimeTitle: 'Your session has reached time limit',
  lifetimeText: 'Due to our security policy we will automatically log you off in approximately 3 minutes. Your session will be restored after logging in',
  lifetimeConfirm: 'Log Off in 3 min',
  lifetimeCancel: 'Log Off Now'
};